import { fileToBase64 } from '@utils/transform';
import axios from 'axios';
import { useState } from 'react';
import { config } from '@config';
import { useCoreClient } from '../queries/client';

const defaultLogoUploadErrorMessage = 'There was an issue uploading your logo';

interface CloudinaryUploadResponse {
  public_id: string;
  secure_url: string;
}

const uploadFile = (uploadFormData: FormData) =>
  axios.post<CloudinaryUploadResponse>(
    `https://api.cloudinary.com/v1_1/${config.cloudinary.cloudName}/image/upload`,
    uploadFormData,
  );

export const useCloudinaryFileUploader = () => {
  const coreClient = useCoreClient();
  const client = coreClient();
  const [loading, setLoading] = useState(false);

  const uploadFileToCloudinary = async (
    file: File,
  ): Promise<CloudinaryUploadResponse | undefined> => {
    setLoading(true);

    let response: CloudinaryUploadResponse | undefined;

    try {
      const base64EncodedFile = await fileToBase64(file);

      if (!base64EncodedFile) {
        setLoading(false);
        return response;
      }

      const timestamp = Date.now();
      const folder = `${config.givzEnv}/merchants`;

      const uploadRequestSignature =
        await client.FileUploads.createUploadSignature({
          fileUploadSignatureRequestCreateDto: {
            folder,
            timestamp,
          },
        });

      if (uploadRequestSignature.errors) {
        // setNotificationError(uploadRequestSignature.errors);
        console.error(uploadRequestSignature.errors);
      } else {
        const uploadFormData = new FormData();
        uploadFormData.append('file', base64EncodedFile);
        uploadFormData.append('upload_preset', 'ml_default');
        uploadFormData.append('folder', folder);
        uploadFormData.append('api_key', config.cloudinary.apiKey);
        uploadFormData.append('timestamp', timestamp.toString());
        uploadFormData.append(
          'signature',
          uploadRequestSignature.data.signature,
        );

        const uploadedFile = await uploadFile(uploadFormData);

        setLoading(false);

        response = uploadedFile.data;
      }
    } catch (error) {
      // setNotificationError(defaultLogoUploadErrorMessage);
      console.error(defaultLogoUploadErrorMessage);
    }

    setLoading(false);
    return response;
  };

  return {
    fileUploadLoading: loading,
    uploadFileToCloudinary,
  };
};
